var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Schema, MapSchema, type } from "@colyseus/schema";
import { GROUND_Y, NET_X, NET_TOP_Y } from "./rules.js";
/**
 * El estado sincronizado de un partido.
 *
 * Es un `Schema` **nuevo y aparte** del campus, y eso no es orden sino seguridad: el
 * orden de los `@type` es el contrato binario de Colyseus, y meter el volley dentro de
 * `Player` o `RoomState` habría puesto campos de un minijuego en medio del contrato de
 * todo el mundo. Una clase nueva empieza limpia y no puede romper a nadie.
 *
 * La regla de siempre sigue valiendo dentro de estas clases: **los campos nuevos van al
 * final.**
 *
 * Acá no hay nada privado —los dos jugadores ven la misma cancha— así que, al revés que
 * en `SocialRoom`, tener estado sincronizado es exactamente lo correcto.
 */
export class VolleyPlayer extends Schema {
    constructor() {
        super(...arguments);
        this.sessionId = "";
        this.accountId = "";
        this.nickname = "";
        /** Índice en AVATAR_COLORS, para que el avatar se vea igual que en el campus. */
        this.color = 0;
        /** 0 izquierda, 1 derecha. */
        this.side = 0;
        /** Posición de los PIES. La integra el servidor; el cliente sólo manda dirección. */
        this.x = 0;
        this.y = GROUND_Y;
        /** Índice en VOLLEY_STANCES. Lo decide el servidor a partir de lo que ve. */
        this.stance = 0;
        this.score = 0;
        /**
         * Es la computadora, no una persona.
         *
         * Va sincronizado porque el rival tiene derecho a saber contra qué juega —y porque la
         * UI tiene que poder decirlo—, y va **al final de la clase**, como manda el contrato
         * binario: un campo insertado en medio rompe la decodificación de todos los clientes.
         */
        this.bot = false;
    }
}
__decorate([
    type("string")
], VolleyPlayer.prototype, "sessionId", void 0);
__decorate([
    type("string")
], VolleyPlayer.prototype, "accountId", void 0);
__decorate([
    type("string")
], VolleyPlayer.prototype, "nickname", void 0);
__decorate([
    type("uint8")
], VolleyPlayer.prototype, "color", void 0);
__decorate([
    type("uint8")
], VolleyPlayer.prototype, "side", void 0);
__decorate([
    type("number")
], VolleyPlayer.prototype, "x", void 0);
__decorate([
    type("number")
], VolleyPlayer.prototype, "y", void 0);
__decorate([
    type("uint8")
], VolleyPlayer.prototype, "stance", void 0);
__decorate([
    type("uint8")
], VolleyPlayer.prototype, "score", void 0);
__decorate([
    type("boolean")
], VolleyPlayer.prototype, "bot", void 0);
export class VolleyState extends Schema {
    constructor() {
        super(...arguments);
        /** Índice en VOLLEY_PHASES. */
        this.phase = 0;
        this.ballX = NET_X;
        this.ballY = NET_TOP_Y;
        /**
         * La velocidad del balón viaja además de su posición.
         *
         * Con parches a 30 Hz, el cliente pinta a mitad de camino entre dos estados: sin la
         * velocidad tendría que adivinar la curva a partir de posiciones pasadas, y un remate
         * —que es justo cuando la trayectoria cambia de golpe— se vería a tirones. Son dos
         * números por parche a cambio de que el momento más importante del juego se vea bien.
         */
        this.ballVx = 0;
        this.ballVy = 0;
        /** Qué lado saca. */
        this.serving = 0;
        /** Toques seguidos del lado que tiene el balón. */
        this.touches = 0;
        /** Último lado que tocó, o -1 si nadie desde el saque. Decide a quién se le va fuera. */
        this.lastTouch = -1;
        /** Lo que queda de partido, en milisegundos. El reloj es del servidor. */
        this.remainingMs = 0;
        /** Ganador, o -1 mientras no lo haya. */
        this.winner = -1;
        this.players = new MapSchema();
    }
}
__decorate([
    type("uint8")
], VolleyState.prototype, "phase", void 0);
__decorate([
    type("number")
], VolleyState.prototype, "ballX", void 0);
__decorate([
    type("number")
], VolleyState.prototype, "ballY", void 0);
__decorate([
    type("number")
], VolleyState.prototype, "ballVx", void 0);
__decorate([
    type("number")
], VolleyState.prototype, "ballVy", void 0);
__decorate([
    type("uint8")
], VolleyState.prototype, "serving", void 0);
__decorate([
    type("uint8")
], VolleyState.prototype, "touches", void 0);
__decorate([
    type("int8")
], VolleyState.prototype, "lastTouch", void 0);
__decorate([
    type("number")
], VolleyState.prototype, "remainingMs", void 0);
__decorate([
    type("int8")
], VolleyState.prototype, "winner", void 0);
__decorate([
    type({ map: VolleyPlayer })
], VolleyState.prototype, "players", void 0);
//# sourceMappingURL=state.js.map